import {Images} from 'appearance'
import {React, styled} from 'common'

const HamburgerButton = ({onClick}) => {
    return (
        <Container onClick={onClick}>
            <HamburgerImage src={Images.HAMBURGER} />
        </Container>
    )
}

export default HamburgerButton

const Container = styled.div`
    height: 100%;
    width: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
`

const HamburgerImage = styled.img`
    width: 32px;
    height: 32px;
`
